
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.929 1.76l-.35.357.35.357 2.452 2.504a2.533 2.533 0 003.26.323l.314.322-2.607 2.663-.35.357.35.357 3.288 3.358v.288h-.281L9.066 9.287l-.35-.357-.35.357-2.578 2.633-.314-.32a2.67 2.67 0 00-.317-3.33L2.705 5.767l-.35-.357-.35.357-.49.501a.198.198 0 01-.281 0 .208.208 0 010-.287L6.138.971a.198.198 0 01.281 0 .208.208 0 010 .288l-.49.5z","fill":"#fff","stroke":"#AAB4C0"}})])
          )
        }
      }
    